import { ActivityFeed } from '@sales-app/types/ActivityFeed'
import { BookablePerson } from '@sales-app/types/BookablePerson'
import { BookablePersonDuplicates } from '@sales-app/types/BookablePersonDuplicates'
import { Lead, PersonDetails } from '@sales-app/types/Person'
import { gql } from 'graphql-request'

import { AttachmentQueries } from '@/graphql/queries/attachments.queries'

export namespace PeopleQueries {
  export namespace GET_BOOKABLE_PERSONS {
    export type Response = { bookablePersons: BookablePerson[] | null }
  }

  export namespace GET_PERSON {
    export type Response = { member: PersonDetails | null }
  }

  export namespace GET_BOOKABLE_PERSON {
    export type Response = { bookablePerson: BookablePerson | null }
  }

  export namespace GET_BOOKABLE_PERSON_DUPLICATES {
    export type Response = { bookablePerson: BookablePersonDuplicates | null }
  }

  export namespace GET_BOOKABLE_PERSON_LEAD {
    export type Response = { lead: Lead | null }
  }

  export namespace GET_BOOKABLE_PERSON_ACTIVITY {
    export type Response = { bookablePerson: { activityFeed: ActivityFeed[] | null; fullName?: string } | null }
  }

  export function getBookablePeople() {
    return gql`
      query getBookablePeople($filter: BookablePersonFilter) {
        bookablePersons(filter: $filter) {
          fullName
          email
          phone
          bookablePersonId
          bookablePersonType
          hasDuplicates
        }
      }
    `
  }

  export function getBookablePerson() {
    return gql`
      query getBookablePerson($bookablePersonRecord: BookablePersonRecord) {
        bookablePerson(bookablePersonRecord: $bookablePersonRecord) {
          firstName
          lastName
          fullName
          email
          phone
          bookablePersonId
          bookablePersonType
          userId
          reservations {
            id
            moveInDate
            moveOutDate
            home {
              id
              searchDocument
              property {
                id
                name
                market {
                  id
                  name
                }
                marketSegment
              }
            }
          }
        }
      }
    `
  }

  export function getBookablePersonDuplicates() {
    return gql`
      query getBookablePersonDuplicates($bookablePersonRecord: BookablePersonRecord) {
        bookablePerson(bookablePersonRecord: $bookablePersonRecord) {
          duplicatesForReview {
            id
            createdAt
            decision
            newBookablePersonId
            newBookablePersonType
            newName
            newEmail
            newPhoneNumber
            originalBookablePersonType
            originalBookablePersonId
            originalName
            originalEmail
            originalPhoneNumber
          }
        }
      }
    `
  }

  export function getBookablePersonActivity() {
    return gql`
      query getBookablePersonActivity($bookablePersonRecord: BookablePersonRecord) {
        bookablePerson(bookablePersonRecord: $bookablePersonRecord) {
          fullName
          activityFeed {
            activityType
            activityId
            agentName
            content
            datetime
            destinationParty
            direction
            displayCity
            externalSource
            externalId
            entityType
            entityId
            home
            homeId
            originatingParty
            reservationId
            attachments {
              ...AttachmentDetails
            }
            childComments {
              id
              createdAt
              text
              richText
              internalOnly
              attachments {
                ...AttachmentDetails
              }
            }
          }
        }
      }
      ${AttachmentQueries.ATTACHMENT_DETAILS}
    `
  }

  export function getPerson() {
    return gql`
      query getPerson($id: Int!) {
        member(id: $id) {
          id
          fullName
          email
          role
          phone
          dateOfBirth
          reservations {
            id
            moveInDate
            moveOutDate
            home {
              id
              searchDocument
              property {
                id
                name
                market {
                  id
                  name
                }
                marketSegment
              }
            }
          }
        }
      }
    `
  }

  export function getBookableLead() {
    return gql`
      query getLead($id: Int!) {
        lead(id: $id) {
          firstName
          lastName
          email
          phone
          id
        }
      }
    `
  }
}
